import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom'; // Добавили Link
function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);
  return (
    <header className={`header-capsule ${isOpen ? 'open' : ''}`}>
      
      {/* Теперь логотип — это ссылка на главную страницу (/) */}
      <Link to="/" className="logo" onClick={closeMenu}>
        <span className="iron">iron</span>
        <span className="vector">vector</span>
      </Link>
      
      <button className="hamburger" onClick={toggleMenu} aria-label="Меню">
        <span></span>
        <span></span>
        <span></span>
      </button>
      <nav className={`nav-links ${isOpen ? 'open' : ''}`}>
        <NavLink onClick={closeMenu} to="/" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>Разработка</NavLink>
        <NavLink onClick={closeMenu} to="/stack" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>Стек</NavLink>
        <NavLink onClick={closeMenu} to="/about" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>Партнер</NavLink>
        <NavLink onClick={closeMenu} to="/contact" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>Связь</NavLink>
      </nav>
    </header>
  );
}
export default Header;